// footer-accordion-controller.js
document.addEventListener('DOMContentLoaded', function() {
  const footerBlocks = document.querySelectorAll('.footer-block');
  
  footerBlocks.forEach(block => {
    const header = block.querySelector('.footer-header-container');
    const content = block.querySelector('.footer-block__details-content');
    
    if (header && content) {
      header.addEventListener('click', function() {
        block.classList.toggle('footer-block--expanded');
        
        if (block.classList.contains('footer-block--expanded')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          content.style.maxHeight = '0px';
        }
      });
    }
  });
});